import { Aux } from './AuxillaryServices';
import { Log } from './Log';
import { ImageCache } from '../Cache/ImageCache';
import { $, jQuery } from '../../vendor/jquery';

/**
 * Interface for classes that cache images
 *
 * @interface ImageCacheService
 */

/**
 * Retrieve and cache image
 * @method
 * @name ImageCacheService#getImage
 * @param {string} url
 * @returns {Promise<string>}
 */

/**
 * Retrieve and Cache image, then replace `src` attribute of image element
 * @method
 * @name ImageCacheService#loadImage
 * @param {string} url
 * @param {Element} elem
 * @returns {Promise<string>}
 */

/**
 * Prefetch list of images
 * @method
 * @name ImageCacheService#prefetchAll
 * @param {Array<string>} urls
 */

/**
 * Check if this service is available
 * @method
 * @name ImageCacheService#serviceAvailable
 * @returns {boolean}
 */

/**
 * Return a Promise that will resolve once the Discovery process has been set to
 * complete
 * @method
 * @name ImageCacheService#waitForDiscoveryComplete
 * @returns {Promise}
 */

/**
 * Set whether the Discovery process has completed or not
 * @method
 * @name ImageCacheService#onDiscoveryComplete
 * @param {boolean} enabled
 */

/**
 * @class
 * @implements {ImageCacheService}
 */
function ImageCacheDOMMutation() {
    'use strict';

    var self = this;

    /**
     * @see ImageCacheService#getImage
     */
    self.getImage = function (origURL) {
        return ImageCache.getCached(origURL);
    };

    /**
     * @see ImageCacheService#loadImage
     */
    self.loadImage = function (origURL, elem) {
        var e = typeof elem == 'string' ? $('#' + elem) : $(elem);

        return self.getImage(origURL).then(
            function (dataURL) {
                e.attr('src', dataURL);
                e.show();
            },
            function () {
                e.attr('src', origURL);
                e.show();
            }
        );
    };

    /**
     * @see ImageCacheService#prefetchAll
     */
    self.prefetchAll = function (urls) {
        if (self.serviceAvailable() && urls.length > 0) {
            self.getImage(urls.shift()).always(function () {
                self.prefetchAll(urls);
            });
        }
    };

    /**
     * @see ImageCacheService#serviceAvailable
     */
    self.serviceAvailable = function () {
        return true;
    };

    /**
     * @see ImageCacheService#waitForDiscoveryComplete
     */
    self.waitForDiscoveryComplete = function () {
        var dfd = jQuery.Deferred();
        dfd.resolve();
        return dfd.promise();
    };

    /**
     * @see ImageCacheService#onDiscoveryComplete
     */
    self.onDiscoveryComplete = function () {};
}

function ImageCacheBase() {}

ImageCacheBase.m_Loaded = false;
ImageCacheBase.Mechanism = null;

ImageCacheBase.onServiceDiscovered = function (event, param) {
    switch (event) {
        case 'Initialize': {
            Log.Info('[Service::ImageCache] Initialize', null, __fileline);

            if (!ImageCacheBase.Mechanism) {
                ImageCacheBase.Mechanism = new ImageCacheDOMMutation();

                Aux.RegisterService('ImageCache', ImageCacheBase.Mechanism);
            }

            break;
        }
        case 'ServicesDiscovered': {
            // This will never be run, but is kept just to confuse everyone.

            Log.Info('[Service::ImageCache] Discovered', null, __fileline);

            ImageCacheBase.Mechanism.onDiscoveryComplete(true);

            break;
        }
        case 'DiscoveryFailed': {
            // This could be considered successful.

            Log.Notice('[Service::ImageCache] Discovery Failed', null, __fileline, {
                event: event,
                param: param,
            });

            ImageCacheBase.Mechanism.onDiscoveryComplete(false);

            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeImageCache() {
    Aux.AddListener(ImageCacheBase.onServiceDiscovered);
}

export { initializeImageCache };
